/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import connect from '../../../utils/connect';
import { FiltersFormContext } from './FiltersFormContext';
import { useFormikContext } from 'formik';
import { Typography, Flex, Select } from '@app/ui';

const BroadcastsFiltersRow = () => {
    const { t } = useTranslation();
    const { values, setFieldValue } = useFormikContext();

    const {
        broadcastNameOptions,
        collectionsOptions,
        setFormValue,
        hasPremiumCollections,
        setSelectedBroadcastNames,
        countryOptions,
        broadcastNetworkOptions,
        hasInternationalBroadcastView,
        isCountrySelectionDisabled,
        isOverridingFilters,
    } = useContext(FiltersFormContext);

    const dropdownWithSelectAll = (selectAll, hasOptions) => menu => (
        <>
            {hasOptions && (
                <div
                    style={{ padding: '8px 12px', cursor: 'pointer' }}
                    onClick={selectAll}
                >
                    <Typography.Text strong>
                        {t('filters.selectAll')}
                    </Typography.Text>
                </div>
            )}
            {menu}
        </>
    );

    const get = key =>
        Object.entries(values[key] ?? {})
            .filter(([, value]) => value)
            .map(([key]) => `${key}`);

    const update = key => v => {
        setFieldValue(
            key,
            v.reduce((acc, value) => {
                acc[value] = true;
                return acc;
            }, {}),
            false,
        );
    };

    return (
        <Flex vertical gap={8} style={{ padding: '16px 0' }}>
            <Flex gap={16} wrap="wrap">
                {hasInternationalBroadcastView && (
                    <Flex vertical flex={1} gap={4}>
                        <Typography.Text
                            className="-filter-title"
                            data-test="new-plt-dropdown"
                        >
                            {t('filters.broadcastCountry')}
                        </Typography.Text>

                        <Select
                            mode="multiple"
                            placeholder={t('filters.selectBroadcastCountry')}
                            options={countryOptions}
                            value={get('countries')}
                            onChange={update('countries')}
                            optionFilterProp="label"
                            allowClear
                            maxTagCount={2}
                            maxTagPlaceholder={`...`}
                            style={{
                                maxHeight: '32px',
                                overflow: 'hidden',
                            }}
                            disabled={
                                isOverridingFilters ||
                                isCountrySelectionDisabled ||
                                countryOptions.length === 0
                            }
                            dropdownRender={dropdownWithSelectAll(() => {
                                update('countries')(
                                    countryOptions.map(({ value }) => value),
                                );
                            }, countryOptions.length > 0)}
                            className="-filter-select"
                        />
                    </Flex>
                )}
                <Flex vertical flex={1} gap={4}>
                    <Typography.Text className="-filter-title">
                        {t('filters.network')}
                    </Typography.Text>
                    <Select
                        mode="multiple"
                        placeholder={t('filters.selectNetworks')}
                        options={broadcastNetworkOptions}
                        value={values.broadcastNetworks}
                        onChange={setFormValue('broadcastNetworks')}
                        optionFilterProp="label"
                        allowClear
                        maxTagCount={1}
                        maxTagPlaceholder="..."
                        style={{ maxHeight: '32px', overflow: 'hidden' }}
                        disabled={
                            isOverridingFilters ||
                            broadcastNetworkOptions.length === 0
                        }
                        dropdownRender={dropdownWithSelectAll(
                            () =>
                                setFormValue('broadcastNetworks')(
                                    broadcastNetworkOptions.map(
                                        ({ value }) => value,
                                    ),
                                ),
                            broadcastNetworkOptions.length > 0,
                        )}
                    />
                </Flex>
                <Flex vertical flex={1} gap={4}>
                    <Typography.Text
                        className="-filter-title"
                        data-test="new-plt-dropdown"
                    >
                        {t('filters.broadcastName')}
                    </Typography.Text>
                    <Select
                        mode="multiple"
                        placeholder={t('filters.selectBroadcastNames')}
                        dropdownMatchSelectWidth={false} // allows custom width
                        dropdownStyle={{ width: 532 }}
                        options={broadcastNameOptions}
                        value={values.broadcastOptions}
                        onChange={setSelectedBroadcastNames}
                        optionFilterProp="label"
                        allowClear
                        maxTagCount={1}
                        maxTagPlaceholder="..."
                        maxTagTextLength={20}
                        style={{ maxHeight: '32px', overflow: 'hidden' }}
                        disabled={
                            isOverridingFilters ||
                            broadcastNameOptions.length === 0
                        }
                        dropdownRender={dropdownWithSelectAll(
                            () =>
                                setSelectedBroadcastNames(
                                    broadcastNameOptions.map(
                                        ({ value }) => value,
                                    ),
                                ),
                            broadcastNameOptions.length > 0,
                        )}
                    />
                </Flex>
                {hasPremiumCollections && (
                    <Flex vertical flex={1} gap={4}>
                        <Typography.Text
                            className="-filter-title"
                            data-test="new-c-dropdown"
                        >
                            {t('filters.collections')}
                        </Typography.Text>
                        <Select
                            mode="multiple"
                            placeholder={t('filters.selectCollections')}
                            options={collectionsOptions}
                            value={values.collections}
                            onChange={setFormValue('collections')}
                            optionFilterProp="label"
                            allowClear
                            maxTagCount={1}
                            maxTagPlaceholder="..."
                            style={{ maxHeight: '32px', overflow: 'hidden' }}
                            autoClearSearchValue={false}
                            disabled={
                                isOverridingFilters ||
                                collectionsOptions.length === 0
                            }
                            dropdownRender={dropdownWithSelectAll(
                                () =>
                                    setFormValue('collections')(
                                        collectionsOptions.map(
                                            ({ value }) => value,
                                        ),
                                    ),
                                collectionsOptions.length > 0,
                            )}
                        />
                    </Flex>
                )}
            </Flex>
        </Flex>
    );
};

export default connect(['filters'])(BroadcastsFiltersRow);
